function enhanceExactMenu(root, doc) {
  const menu = root.querySelector('[data-armmy-menu]');
  const viewport = doc.defaultView?.matchMedia?.('(max-width: 1099px)');
  if (typeof menu?.addEventListener !== 'function' || !viewport) return;
  const summary = menu.querySelector('summary');
  const sync = () => { menu.open = !viewport.matches; };
  sync();
  viewport.addEventListener('change', sync);
  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && viewport.matches && menu.open) {
      menu.open = false;
      summary?.focus();
      event.preventDefault();
    }
  });
  menu.addEventListener('click', (event) => {
    if (viewport.matches && event.target.closest('a')) menu.open = false;
  });
  doc.addEventListener('shopify:section:unload', (event) => {
    if (event.target?.contains(root)) viewport.removeEventListener('change', sync);
  });
}

export function enhanceExactHome(root, doc = document) {
  if (!root || root.dataset.armmyEnhanced === 'true') return;
  root.dataset.armmyEnhanced = 'true';
  enhanceExactMenu(root, doc);
  root.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-armmy-action]');
    if (!link || !root.contains(link)) return;
    const action = link.dataset.armmyAction;
    if (action !== 'search' && action !== 'cart') return;
    const service = action === 'search' ? doc.querySelector('#search-modal') : doc.querySelector('cart-drawer-component');
    const method = action === 'search' ? 'showDialog' : 'open';
    if (typeof service?.[method] !== 'function') return;
    try {
      service[method]();
      event.preventDefault();
    } catch {
      // Keep the real search/cart destination when a native service cannot open.
    }
  });
  doc.addEventListener('cart:update', (event) => {
    if (!root.isConnected) return;
    const data = event.detail?.data;
    let count = event.detail?.resource?.item_count;
    if (!Number.isInteger(count)) {
      if (data?.didError) return;
      count = data?.itemCount;
      if (data?.source === 'product-form-component' && Number.isInteger(count)) {
        const previous = Number(root.querySelector('[data-armmy-cart-count]')?.textContent);
        if (!Number.isInteger(previous)) return;
        count += previous;
      }
    }
    if (!Number.isInteger(count) || count < 0) return;
    root.querySelectorAll('[data-armmy-cart-count]').forEach((node) => { node.textContent = String(count); });
    root.querySelectorAll('[data-armmy-action="cart"]').forEach((node) => { node.setAttribute('aria-label', `Cart, ${count} items`); });
  });
}

function initializeExactHome(scope = document) {
  scope.querySelectorAll('[data-armmy-exact-home]').forEach((root) => enhanceExactHome(root));
}
if (typeof document !== 'undefined') {
  initializeExactHome();
  document.addEventListener('shopify:section:load', (event) => initializeExactHome(event.target));
}
